import Vue from 'vue';
import dayjs from 'dayjs';

Vue.filter('displayDate', (value) => {
  const formattedDate = value ? dayjs(value).format('DD.MM.YYYY') : '';
  return formattedDate;
});

Vue.filter('tableDate', (value) => {
  const formattedDate = value ? dayjs(value).format('D MMM YYYY') : '';
  return formattedDate;
});

Vue.filter('issueDate', (value) => {
  const formattedDate = value ? dayjs(value).format('HH:MM - D MMM YYYY') : '';
  return formattedDate;
});
